module.exports = __webpack_public_path__ + "static/img/ptld_4.71cb94fa.png";